export const USERNAME_TAKEN_ERROR_MESSAGE = "Username is already taken";
export const FALLBACK_MESSAGE = "Oops! Something went wrong. Please try again. If the issue persists, contact support.";
export const NSFW_GATING_REASONS = {
    AGE_VERIFICATION_REQUIRED: "AGE_VERIFICATION_REQUIRED",
    GUEST_ACCESS_LIMITED: "GUEST_ACCESS_LIMITED",
};
